import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './HotelIdCell.module.scss'

const HotelIdCell = ({ displayId, noHoverStyle, ...props }) => (
  <Cell className={styles.idCell} {...props}>
    #{displayId}
  </Cell>
)

export default HotelIdCell
